export default __webpack_public_path__ + "static/media/quickview_welcome.f90c4e18.svg";